export class Grade
{
    public GradeId : number;
    public GradeCode : string;
    public GradeName : string;
    public LevelId : number;
    public DecisionId : number;
    public IsActive : boolean;
    public NoticePeriod : number; 
}